// extracted by mini-css-extract-plugin
module.exports = {"button--default":"RSButtonAnchor_button--default__zFPnB","icon-wrapper":"RSButtonAnchor_icon-wrapper__Gol21","spin":"RSButtonAnchor_spin__7YM1v"};